import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Copy, Check } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL || '';

const TechConfigApp = ({ chantierId }) => {
  const [data, setData] = useState(null);
  const [copie, setCopie] = useState(null);

  useEffect(() => {
    axios.get(`${API}/api/chantiers/${chantierId}/codes-barres`)
      .then((r) => setData(r.data.data))
      .catch(() => setData(null));
  }, [chantierId]);

  if (!data) return null;

  const copier = (numero) => {
    navigator.clipboard?.writeText(numero);
    setCopie(numero);
    if (navigator.vibrate) navigator.vibrate(40);
    setTimeout(() => setCopie(null), 1500);
  };

  const ligne = (c) => (
    <div key={c.id}
      style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '12px', padding: '11px 0', borderTop: '1px solid #F3F4F6' }}>
      <div style={{ minWidth: 0 }}>
        <div style={{ fontSize: '15px', fontFamily: 'monospace', letterSpacing: '0.5px' }}>
          {c.numero}
        </div>
        {(c.panneaux || []).length > 0 && (
          <div style={{ fontSize: '12px', color: '#059669', marginTop: '3px' }}>
            Panneau{c.panneaux.length > 1 ? 'x' : ''} {c.panneaux.join(' et ')}
          </div>
        )}
      </div>
      <button onClick={() => copier(c.numero)}
        style={{
          width: '38px', height: '38px', flexShrink: 0, borderRadius: '9px',
          border: `1px solid ${copie === c.numero ? '#A7F3D0' : '#E5E7EB'}`,
          background: copie === c.numero ? '#ECFDF5' : '#fff',
          color: copie === c.numero ? '#059669' : '#6B7280',
          display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', padding: 0,
          transition: 'all .15s'
        }}>
        {copie === c.numero ? <Check size={16} /> : <Copy size={16} />}
      </button>
    </div>
  );

  const bloc = { border: '1px solid #E5E7EB', borderRadius: '10px', padding: '14px', marginBottom: '14px' };

  return (
    <div>
      <div style={{ fontSize: '13px', color: '#6B7280', lineHeight: 1.55, marginBottom: '16px' }}>
        Recopiez ces numéros dans l'application APSystems pour configurer l'installation.
      </div>

      <div style={bloc}>
        <div style={{ fontSize: '15px', fontWeight: 500, marginBottom: '4px' }}>
          Micro-onduleurs
          <span style={{ color: '#9CA3AF', marginLeft: '6px', fontWeight: 400 }}>
            {(data.micro_onduleurs || []).length}
          </span>
        </div>
        {(data.micro_onduleurs || []).length === 0 ? (
          <div style={{ fontSize: '13px', color: '#9CA3AF', paddingTop: '8px' }}>Aucun numéro scanné</div>
        ) : (data.micro_onduleurs || []).map(ligne)}
      </div>

      <div style={bloc}>
        <div style={{ fontSize: '15px', fontWeight: 500, marginBottom: '4px' }}>
          Passerelle
          <span style={{ color: '#9CA3AF', marginLeft: '6px', fontWeight: 400 }}>
            {(data.passerelles || []).length}
          </span>
        </div>
        {(data.passerelles || []).length === 0 ? (
          <div style={{ fontSize: '13px', color: '#9CA3AF', paddingTop: '8px' }}>Aucun numéro scanné</div>
        ) : (data.passerelles || []).map(ligne)}
      </div>
    </div>
  );
};

export default TechConfigApp;
